import SideMenu from '../../Splitter/SideMenu/SideMenu';
import { calendrier } from '../../../utils/images';
import React, { useContext, useRef, useEffect } from 'react';
import { ClientContext } from '../../Contexts/contexts';
import HeaderMinimal from '../../Shared/Headers/HeaderMinimal';
import QuoteElementUser from '../QuoteElementUser/QuoteElementUser';
import useAuth from '../../Contexts/useAuth';

function AcceptedRdvUser() {
  const clientContext = useContext(ClientContext);

  const { checkAuth, validateRoleRoute } = useAuth();
  const ref = useRef(true);

  function getAppointmentByQuote(relationId) {
    return clientContext?.appointments?.find(
      (appointment) =>
        appointment?.clientExpertRelationshipId === relationId &&
        appointment.acceptedByClient === true
    );
  }

  useEffect(() => {
    const firstRendering = ref.current;

    if (checkAuth()) {
      if (validateRoleRoute('client')) {
        if (firstRendering) {
          ref.current = false;
          clientContext?.refreshClientExpertRelations();
        }
      }
    }
  }, [checkAuth, validateRoleRoute, clientContext]);

  return (
    <>
      <HeaderMinimal />
      <div className="ts-container">
        <SideMenu />
        <div className="ts-container-column">
          <div className="ts-details-container">
            <div className="ts-details">
              <div className="ts-title">Rendez-vous accepté</div>
              <div className="ts-resume">
                Félicitations ! Vous avez confirmé un rendez-vous avec votre
                expert-comptable.
                <br />
                Désormais, vous pouvez accéder à ses coordonnées et le contacter
                avant votre rendez-vous prévu.
              </div>
            </div>
            <div className="ts-number">
              <div className="ts-number-container">
                <div className="ts-number-title">Rendez-vous accepté</div>
                <div className="ts-number-current">1</div>
              </div>
              <img className="ts-icon" src={calendrier} alt="devis icone"></img>
              <div className="purple-rod"></div>
            </div>
          </div>
          {clientContext?.clientExpertRelations
            ?.filter(
              (relation) =>
                relation?.status >= 2 || relation?.clientSigned === 0
            )
            ?.map((relation) => (
              <div className="rdv-container" key={relation.id}>
                <div className="rdv-elements-container">
                  <QuoteElementUser
                    id={relation.id}
                    clientExpertRelation={relation}
                    appointment={getAppointmentByQuote(relation.id)}
                  />
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}

export default AcceptedRdvUser;
